import { useEffect, useRef, useState } from 'react';

export const useNearScreen = () => {
  const [isNearScreen, setIsNearScreen] = useState(false);
  // Its like: const ref = document.getElementById('elementId');
  const elementRef = useRef(null);

  useEffect(() => {
    generateLazyLoad();
  }, [elementRef]);

  /**
   * Dinamic import of polyfill intersection-observer
   * We need load intersection-observer if our browser dont support window.IntersectionObserver
   * Maybe we need install @babel/plugin-syntax-dynamic-import --save-dev in order 'import' works
   * and we add the plugin in webpack.config as plugin
   */
  const checkIntersectionObserver = async () => {
    Promise.resolve(
      typeof window.IntersectionObserver !== 'undefined'
        ? window.IntersectionObserver
        : import('intersection-observer')
    );
  };
  const generateLazyLoad = async () => {
    await checkIntersectionObserver();
    const observer$ = new window.IntersectionObserver((entries) => {
      // isIntersecting tell us if elements is rendered in viewport
      const { isIntersecting } = entries[0];
      if (isIntersecting) {
        setIsNearScreen(true);
        // When element is in viewport we disconnect the observer in order to avoid future calls
        observer$.disconnect();
      }
    });
    // What element may I observe?
    //console.log(elementRef.current);
    observer$.observe(elementRef.current);
  };

  return { isNearScreen, elementRef };
};
